import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'audit/';

class AuditService {
    // params: { missionId?, limit?, offset? }
    getMissionLogs(params = {}) {
        return axios.get(API_URL + 'missionlogs', {
            params,
            headers: authHeader()
        });
    }
}

export default new AuditService();
